import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from 'react-icons/ai';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import bureaucrat from '../../util/Bureaucrat';
import { parseErrorMessage } from '../util/dataHelpers';
import { getLogger } from '../../util/logger';

const logger = getLogger('CheckEdge');

function checkEdgeRow(label, content) {
  const color = label === 'Error:' ? 'red' : 'black';
  return (
    <p key={label} style={{ color }}>
      <span style={{ display: 'inline-block', width: '45px' }}>{label}</span>
      {content}
    </p>
  );
}

function rowWithErrorCheck(label, value, errorReason, reportError) {
  if (value !== undefined) {
    const ok = <AiOutlineCheckCircle style={{ color: 'green' }} />;
    const failed = (
      <>
        <AiOutlineCloseCircle style={{ color: 'rgb(230, 0, 0)' }} />
        <span style={{ color: 'rgb(230, 0, 0)' }}>
          &nbsp;&nbsp;{errorReason}
        </span>
      </>
    );

    if (!value) {
      logger.error(`${label} ${errorReason}`);
      reportError(true);
    } else {
      logger.debug(`${label} success`);
    }
    return checkEdgeRow(label, value ? ok : failed);
  }

  return null;
}

function row(label, value) {
  if (value !== undefined) {
    logger.debug(`${label} ${value}`);
    return checkEdgeRow(label, value);
  }

  return null;
}

function CheckEdge({ show, setShow, skypeDomain }) {
  const defaultItems = [<p key="checking">Checking...</p>];
  const [items, setItems] = useState(defaultItems);
  const history = useHistory();

  useEffect(() => {
    if (!show) {
      return;
    }
    let errorReported = false;

    function reportError() {
      errorReported = true;
    }

    bureaucrat
      .checkEdge(skypeDomain)
      .then((values) => {
        const errorReason = values.errorReason ? values.errorReason : '';
        const newItems = [
          row('SRV:', values.serviceName),
          row('Host:', values.resolvedHost),
          row('Port:', values.resolvedPort),
          row('IP:', values.resolvedIp),
          rowWithErrorCheck(
            'TCP:',
            values.tcpConnect,
            errorReason,
            reportError,
          ),
          rowWithErrorCheck(
            'TLS:',
            values.tlsConnect,
            errorReason,
            reportError,
          ),
          rowWithErrorCheck(
            'SIP:',
            values.sipConnect,
            errorReason,
            reportError,
          ),
          row('Cert:', values.certDN),
          !errorReported && errorReason.length > 0 && (
            <p key="error">
              <strong style={{ color: 'rgb(230, 0, 0)' }}>{errorReason}</strong>
            </p>
          ),
        ];

        if (!errorReported && errorReason.length > 0) {
          logger.error(errorReason);
        }

        setItems(newItems);
      })
      .catch((error) => {
        function setErrorMsg(errorMsg) {
          setItems([checkEdgeRow('Error:', errorMsg)]);
        }

        parseErrorMessage(error, setErrorMsg, history);
      });
  }, [skypeDomain, show, history]);

  const handleHide = () => {
    setShow(false);
    setItems(defaultItems);
  };

  return (
    <Modal show={show} size="lg" onHide={handleHide}>
      <Modal.Header closeButton>
        <Modal.Title>Check edge results for {skypeDomain}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{items}</Modal.Body>
    </Modal>
  );
}

CheckEdge.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  skypeDomain: PropTypes.string,
};
export default CheckEdge;
